import React from 'react';
import { Box, Typography } from '@material-ui/core';

const UserEdit: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">User Edit</Typography>
      <Typography variant="body1">User Edit component - To be implemented</Typography>
    </Box>
  );
};

export default UserEdit; 